<template>
  <div class="editor-container">
    <vue-editor v-model="content" :editor-toolbar="customToolbar" @input="updateContent" />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  components: { VueEditor },
  props: {
    value: {
      type: String,
      default: '<p>Comece a editar aqui...</p>',
    },
  },
  data() {
    return {
      content: this.value,
      customToolbar: [
        ['bold', 'italic', 'underline'],
      ],
    }
  },
  methods: {
    updateContent() {
      this.$emit('input', this.content)
    },
  },
  watch: {
    value(newVal) {
      this.content = newVal
    },
  },
}
</script>

<style>
.editor-container .ql-toolbar {
  border: none !important;
  background: transparent !important;
  padding: 8px !important;
  border-radius: 8px !important;
}

.editor-container .ql-toolbar .ql-formats {
  margin: 0 !important;
}

.editor-container .ql-toolbar button {
  width: 40px !important;
  height: 40px !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  margin: 0 4px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-weight: bold !important;
  color: #000000 !important;
  transition: background-color 0.2s !important;
}

.editor-container .ql-toolbar button:hover {
  background-color: #f0f0f0 !important;
}

.editor-container .ql-container {
  background-color: #FFF !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  margin-top: 8px !important;
}
</style>